<template>
    <CRow class="mt-3">
        <CCol col="12" sm="12" md="10" lg="7" xl="6" class="mx-auto">
            <PersonalInformationForm :user="user" :submit="submit">
                <template #submitBtn="{invalid}">
                    <CCol col="12" class="b-t-1 pt-2 mt-3">
                        <CButton :disabled="invalid  || !((user.birth_certificate && user.national_card) || user.identity_type === UserIdentifyType.LEGAL)" type="submit"  color="primary" class="px-4 mr-auto d-block">{{ $t('btn.next_step') }}</CButton>
                    </CCol>
                </template>
            </PersonalInformationForm>
        </CCol>
    </CRow>
</template>

<script>
import { mapActions } from 'vuex'
import { UserIdentifyType, UserSetupStatus } from '@/constants'
import PersonalInformationForm from '@/views/users/components/PersonalInformationForm'

export default {
    name: 'PersonalInformation',

    components: {
        PersonalInformationForm
    },

    data() {
        return {
            UserIdentifyType,
        };
    },

    computed: {
        user() {
            return this.$currentUser();
        }
    },

    methods: {
        ...mapActions({
            edit: "user/edit",
            changeCurrentUserSetupStatus: "user/changeCurrentUserSetupStatus",
            setMsg: "messageComponent/setMsg",
            resetMsg: "messageComponent/resetMsg",
            setShowLoading: "loadingComponent/setShowLoading"
        }),
        clearMsg() {
            this.resetMsg();
        },
        submit() {
            this.setShowLoading();
            this.resetMsg();
            const data = {
                id: this.user.id,
                telephone: this.user.telephone,
                city: this.user.city,
                national_code: this.user.national_code,
                identity_type: this.user.identity_type,
                postal_code: this.user.postal_code,
                address: this.user.address,
                province: this.user.province,
                township: this.user.township,
                avatar: this.user.avatar,
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                registration_number: this.user.registration_number,
                economic_code: this.user.economic_code,
                legal_name: this.user.legal_name,
                birth_certificate: this.user.birth_certificate,
                national_card: this.user.national_card,
                representative_name: this.user.representative_name,
                representative_phone: this.user.representative_phone,
                representative_email: this.user.representative_email,
                // email: this.user.email,
                // phone: this.user.phone,
            };
            this.edit(data).then(() => {
                this.changeCurrentUserSetupStatus(this.$policy("store").join ? UserSetupStatus.FINANCIAL_INFO : UserSetupStatus.STORE_INFO).then(() => {
                    this.setShowLoading(false);
                });
            })
                .catch(result => {
                this.setShowLoading(false);
                this.setMsg({
                    content: this.$t("tags." + result.tag),
                    type: "danger"
                });
            });
        }
    },
    components: { PersonalInformationForm }
}
</script>